import React from "react";
import { Label } from "flowbite-react";
import { useTranslation } from "../hooks/useTranslation.ts";

export type Period = "1M" | "3M" | "YTD" | "1Y" | "2Y" | "3Y" | "5Y" | "10Y" | "ALL";

interface PeriodSelectorProps {
  selectedPeriod: Period;
  onPeriodChange: (period: Period) => void;
  label?: string;
  className?: string;
  periods?: Period[];
  translationNamespace?: "performanceChart" | "settings";
}

const DEFAULT_PERIODS: Period[] = ["YTD", "1Y", "2Y", "3Y", "5Y", "10Y"];

/**
 * Reusable Period Selector Component
 * Used for selecting time periods in various parts of the application
 */
export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  selectedPeriod,
  onPeriodChange,
  label,
  className = "",
  periods = DEFAULT_PERIODS,
}) => {
  const { tCommon } = useTranslation();

  const getPeriodLabel = (period: Period): string => {
    return tCommon(`periods.${period}`);
  };

  return (
    <div className={className}>
      {label && (
        <Label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </Label>
      )}
      <div
        className="flex rounded-lg border overflow-hidden"
        style={{ borderColor: "#e5e7eb" }}
      >
        {periods.map((period, index) => (
          <button
            key={period}
            type="button"
            onClick={() => onPeriodChange(period)}
            className={`flex-1 px-2 py-2 text-xs font-medium transition-colors duration-200 cursor-pointer hover:bg-gray-50 ${
              index < periods.length - 1 ? "border-r" : ""
            }`}
            style={{
              borderColor: "#e5e7eb",
              backgroundColor: selectedPeriod === period ? "#F9FAFB" : "white",
              color: selectedPeriod === period ? "#1A56DB" : "#374151",
            }}
          >
            {getPeriodLabel(period)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PeriodSelector;
